import { render, staticRenderFns } from "./propertyTypeForm.vue?vue&type=template&id=a20ef8c8&%23default=true&"
import script from "./propertyTypeForm.vue?vue&type=script&lang=js&"
export * from "./propertyTypeForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports